export default {
	URLS_DOCS: {
		1: {
			img: "negro.jpg"
		},
		2: {
			img: "negrorojo.jpg"
		},
		3: {
			img: "honor.jpg"
		},
		4: {
			img: "confraternizacion.jpg"
		}
	},
	LABEL_PHOTOS: {
		1: "negro",
		2: "negrorojo",
		3: "honor",
		4: "confrater"
	},
	NUMBER_PHOTOS: {
		1: 169,
		2: 34,
		3: 10,
		4: 32
	}
}
